<section class="container" *ngIf="principalesCambios$ | async as principalesCambios; else loadingTpl">
    <div class="header">
        <h2>Principales cambios</h2>
        <p>Te contamos cuáles han sido los cambios más importantes de la Reforma de Pensiones.</p>
    </div>

    <div class="changes-container">
        <div class="sidebar" [class.has-left-overflow]="canScrollLeft"
            [class.has-right-overflow]="canScrollRight">
            <div class="sidebar-content" #changesTrack (scroll)="updateScrollState()" role="tablist">
                <button type="button" *ngFor="let cambio of principalesCambios" class="change-item"
                    [class.active]="cambio.key === selectedCambio" [attr.aria-selected]="cambio.key === selectedCambio"
                    role="tab" (click)="selectCambio(cambio.key)">
                    <span>{{ cambio.titulo }}</span>
                    <icon-beneficios-reforma-flecha-menu class="change-arrow" aria-hidden="true"></icon-beneficios-reforma-flecha-menu>
                </button>
            </div>
            <button type="button" class="changes-arrow changes-arrow-left" *ngIf="canScrollLeft"
                aria-label="Ver cambios anteriores" (click)="scrollChanges('left')">
                <icon-beneficios-reforma-flecha-menu aria-hidden="true"></icon-beneficios-reforma-flecha-menu>
            </button>
            <button type="button" class="changes-arrow changes-arrow-right" *ngIf="canScrollRight"
                aria-label="Ver más cambios" (click)="scrollChanges('right')">
                <icon-beneficios-reforma-flecha-menu aria-hidden="true"></icon-beneficios-reforma-flecha-menu>
            </button>
        </div>

        <div class="main-content" role="tabpanel">
            <div [ngSwitch]="selectedCambio">
                <ng-container *ngFor="let cambio of principalesCambios">
                    <div @fadeInOut *ngSwitchCase="cambio.key" class="detail-content">
                        <p class="introduction" [innerHTML]="cambio.introduccion"></p>
                        <h3 *ngIf="cambio.subtitulo">{{ cambio.subtitulo }}</h3>
                        <p *ngFor="let parrafo of cambio.contenido" [innerHTML]="parrafo"></p>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section>

<ng-template #loadingTpl>
  <app-text-skeleton [lines]="5"></app-text-skeleton>
</ng-template>